<template>
    <div class="row">
        <!-- Begin container Course  -->
        <div class="col-md-12 pb-0" style="background-color: #eaeaea; margin-bottom: 5px; padding-top: 3px; padding-bottom: 5px !important;"><u class="section-title"><i class="fas fa-chalkboard"></i>&nbsp;&nbsp;{{ course.title }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></div>
        <div class="col-xs-12 col-sm-12 col-md-9" >
            <div v-if="title">

                <div class="shadow" style="background-color: #d5d5d5; padding-top: 5px; padding-left: 8px;"><label><i class="fas fa-angle-double-right"></i> <u>Módulo: {{title}}</u></label> <span v-if="title!= 'Introducción' && moduleProgress.status==1"></span></div>

                <section class="ex-media-player shadow">
                    <div class="card">
                        <div class="card-body">
                            <div v-if="title!='Introducción'" class="bg-text mb-2 p-1">
                                <h5><b><u>Progreso del Módulo:</u></b></h5>
                                <div class="row">
                                    <div class="col-6">
                                        <span for=""><i class="fas fa-eye"></i><b> Lectura:</b></span>
                                        <div class="progress mb-0">
                                            <div class="progress-bar" role="progressbar" :aria-valuenow="readPrecent" aria-valuemin="0" aria-valuemax="100" :style="{ width: readPrecent + '%' }">{{readPrecent}}%</div>
                                        </div>
                                        <cite class="" style="font-size: 11px;">
                                            <div class="row">
                                                <div class="col-md-12"><b>Tiempo: {{ moduleProgress.read_time }} </b> / {{ readTime }}</div>
                                            </div>
                                        </cite>
                                    </div>
                                    <div class="col-6">
                                        <span for=""><i class="fas fa-pencil-ruler"></i><b> Practica:</b></span>
                                        <div class="progress mb-0">
                                            <div class="progress-bar bg-warning" role="progressbar" :aria-valuenow="practicePrecent" aria-valuemin="0" aria-valuemax="100" :style="{ width: practicePrecent + '%' }">{{practicePrecent}}%</div>
                                        </div>
                                        <cite class="" style="font-size: 11px;">
                                            <div class="row">
                                                <div class="col-md-7"><b>Tiempo: {{ moduleProgress.practice_time }} </b> / {{ practiceTime }}</div>
                                                <div class="col-md-5"><b>Puntos: {{ moduleProgress.score }}</b> / 100</div>
                                            </div>
                                        </cite>
                                    </div>
                                    <div class="col-12 text-right">
                                        <hr>
                                        <button class="btn btn-primary btn-sm" @click="showRead()"><i class="fas fa-eye"></i> Leer Módulo</button>
                                        <button class="btn btn-warning btn-sm" @click="showTest(id, type='practico')"><i class="fas fa-pencil-ruler"></i> Examen de Practica</button>
                                        <button v-if="readPrecent>=100" class="btn btn-success btn-sm" @click="showTest(id, type='municipal')"><i class="fas fa-spell-check"></i> Examen Municipal</button>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-text mb-2">
                                <video-intro v-if="video" :key="title + id" :courseid="id" :src="videoUrl"></video-intro>
                                <hr v-if="video && description" class="mb-0">
                                <div v-if="description" class="text-justify p-2 mt-0" v-html="description"></div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>

        <!-- End container Course  -->

        <!-- Begin Nav-bar Right Course  -->
        <div v-if="course.id" class="col-xs-12 col-sm-12 col-md-3 p-0 shadow" style="background-color: #FFFFFF; height: 100%;" >
            <div style="background-color: #d5d5d5; padding-top: 5px; padding-left: 8px;"><label><i class="feather icon-layers"></i> <u>Módulos</u></label></div>
            <b-overlay :show="loading" rounded="sm">
                <div style="background-color: #e5e5e5; margin-top: 4px;">
                    <a href="#" @click.prevent="loadModule('Introducción', course, value=0)">
                        <span style="margin-top: 4px; padding-left: 10px;"><i class="fas fa-angle-double-right" ></i>
                            <b v-if="title === 'Introducción'">Introducción </b>
                            <span v-else>Introducción</span>
                        </span>
                    </a>
                </div>

                <!-- Iterar sobre los módulos -->
                <div v-for="(module, index) in modules" :key="index">
                    <div style="background-color: #e5e5e5; margin-top: 4px; padding-left: 10px;">
                        <a v-if="module.status>=1" @click.prevent="loadModule(module.module.module , module, value=1)" data-toggle="collapse" :href="'#module' + module.module.id" role="button" aria-expanded="false" :aria-controls="'module' + module.module.id">
                            <span v-if="module.status>=1" style="margin-top: 4px;">
                                <i v-if="module.status<=1" class="fas fa-angle-double-right"></i>
                                <i v-if="module.status>=2" class="far fa-check-square"></i>
                                <b v-if="title === module.module.module">{{ module.module.module }}</b>
                                <span v-else>{{ module.module.module }}</span>
                            </span>
                        </a>
                        <span v-else >
                            <span style="margin-top: 4px; color: #8c8c8c;"><i class="fas fa-angle-double-right"></i> {{ module.module.module }}</span>
                        </span>
                    </div>
                    <!-- {{ module.module }} -->
                <!-- Iterar sobre los temas del módulo -->
                <div class="collapse" :id="'module' + module.module.id">
                    <div style="">
                        <ul style="font-size: 12px; padding-left: 1px !important;">
                            <li v-for="(topic, topicIndex) in module.module.sortedTopics" :key="topicIndex" style="background-color: #f1f1f1; margin-top: 2px; padding-left: 18px !important;">
                                <span><i class="fas fa-caret-right"></i>&nbsp;&nbsp;{{ topic.topic }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                </div>
                <div style="padding-bottom: 4px !important;"></div>
            </b-overlay>
        </div>
        <!-- End Nav-bar Right Course  -->
        <modal-test v-if="showModalTest" :data="data" :typeExamen="typeExamen" :showModal.sync="showModalTest" @loadProgress="loadProgress"></modal-test>
        <modal-read v-if="showModalRead" :data="data" :showModal.sync="showModalRead" @loadProgress="loadProgress"></modal-read>
    </div>
</template>

<script>

import ModalTest from './partials/ModalTest.vue';
import ModalRead from './partials/ModalRead.vue';
import VideoIntro from './partials/VideoIntro.vue';
import { BOverlay } from 'bootstrap-vue';

export default {
    components: {VideoIntro, ModalTest, ModalRead, BOverlay},
    props: ['courseid'],
    data() {
        return {
            course_id: null,
            course: {
                'id': null,
                'title': null,
                'description': null,
                'video': null,
            },
            moduleProgress: {
                'id': null,
                'read_time': '00:00:00',
                'practice_time': '00:00:00',
                'status': null,
            },
            modules: [],
            data: [],
            loading: false,
            topics: [],
            id: null,
            moduleId: null,
            title: null,
            description: null,
            video: null,
            videoUrl: null,
            url: null,
            readTime: null,
            practiceTime: null,
            score: null,
            readPrecent: null,
            practicePrecent: null,
            showModalTest: false,
            typeExamen: null,
            showModalRead: false,
        }
    },
    mounted() {
        this.getCourse();
    },
    methods: {
        getCourse() {
            this.loading = true
            axios.get(`/getCourse/${this.courseid}`)
                .then(response => {
                    if(response.data.data){
                        this.course = {
                            'id': response.data.data.id,
                            'title': response.data.data.course,
                            'description': response.data.data.description,
                            'video': response.data.data.video,
                        };
                        this.url = response.data.data.url;
                        this.getModules(this.course.id);
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false
                });
        },
        getModules() {
            this.loading = true
            axios.get(`/getModules/${this.courseid}`)
                .then(response => {
                    if(response.data.data){
                        this.modules = response.data.data;
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false
                });
        },
        async getModuleProgress(module_id) {
            return await axios.get(`/getModuleProgress/${module_id}`)
                .then(response => {
                    this.moduleProgress = {
                        'id': response.data.data.id,
                        'mycourse_id': response.data.data.mycourse_id,
                        'read_time': response.data.data.read_time,
                        'practice_time': response.data.data.practice_time,
                        'score': response.data.data.score,
                        'status': response.data.data.status,
                    };
                    return this.moduleProgress; // Devolver los datos para encadenar .then correctamente
                })
                .catch(error => {
                    console.error(error);
                    throw error; // Relanzar el error para que pueda ser manejado en la cadena de promesas
                });
        },
        loadModule(title, data, value) {

            this.title = title;




            //Load container with data of course
            if(value==0){
                this.id = data.id;
                this.description = data.description;
                if(data.video!=null){ this.video = data.video; }else{this.video = null}
                this.videoUrl = null;
            }
            //Load container with data of module
            if(value==1){
                this.id = data.module.id;
                this.readTime = data.module.read_time;
                this.practiceTime = data.module.practice_time;
                this.description = data.module.description;
                this.video = data.module.video || null;
                this.videoUrl = data.module.url_video || null;
                this.data=data.module;
                //Load progress of module
                this.loadProgress(data.id)
            }
            this.data.url= this.url;
            this.data.courseid= parseInt(this.courseid);

        },
        loadProgress(id, reponse = null){
            this.getModuleProgress(id).then(() => {

                let readTime = localStorage.getItem('read_time');
                this.readPrecent = this.precentTime(this.readTime, this.moduleProgress.read_time);
                this.practicePrecent = this.precentTime(this.practiceTime, this.moduleProgress.practice_time);
                this.practicePrecent = this.precentTime(this.practiceTime, this.moduleProgress.practice_time);
                this.data.moduleProgress= this.moduleProgress;

                if(this.readPrecent>=100 && this.moduleProgress.status==2){
                    this.getModules();
                }

            });

        },
        convertSeconds(time) {
            const partsTime = time.split(":");
            return partsTime[0] * 3600 + partsTime[1] * 60 + partsTime[2] * 1;
        },
        precentTime(readTime, read_time_progress){
            let result = 0;
            if(this.convertSeconds(read_time_progress) >= this.convertSeconds(readTime)){
                return result = 100;
            }else{
                // Convertir tiempo requerido y progreso a segundos totales
                const timerequeredSeconds = this.convertSeconds(readTime);
                const progressSeconds = this.convertSeconds(read_time_progress);

                // Calcular el porcentaje
                let percent = Math.round((progressSeconds / timerequeredSeconds) * 100);
                result = percent === 100 ? percent.toString() : percent.toString().padStart(2, '0');
                return result;
            }

        },
        showTest(module_id, type) {
            this.moduleId = module_id;
            this.showModalTest = true;
            this.typeExamen = type;
        },
        showRead() {
            this.showModalRead = true
        },

    }
}
</script>